import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PreviewDeviceHolderComponent } from './device-holder/preview-device-holder.component';

const routes: Routes = [
  {
    path: 'ui-builder',
    loadChildren: () => import('./modules/ui-builder/ui-builder.module').then((mod) => mod.UiBuilderModule),
  },
  {
    path: 'back-office',
    loadChildren: () =>
      import('./modules/back-office/back-office.module').then((mod) => mod.BackOfficeModule),
  },
  {
    path: 'admin-portal',
    loadChildren: () => import('./modules/admin-portal/admin-portal.module').then((mod) => mod.AdminPortalModule),
  },
  {
    path: 'app-preview',
    component: PreviewDeviceHolderComponent,
  },
  { path: ' ', redirectTo: 'back-office/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'back-office/dashboard', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
